import type { PropsWithChildren } from "react";
import { useLayoutEffect, useRef, useState } from "react";
import { tv } from "tailwind-variants";

const revealVariants = tv({
  base: "-m-1.5 box-content overflow-hidden p-1.5 transition-all duration-300 ease-out",
});

export type RevealProps = PropsWithChildren<{
  className?: string;
}>;

export const Reveal = ({ children, className }: RevealProps) => {
  const content = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    const element = content.current;

    if (!element) {
      return;
    }

    const observer = new ResizeObserver(() => {
      return setHeight(element.getBoundingClientRect().height);
    });

    observer.observe(element);

    return () => {
      return observer.disconnect();
    };
  }, []);

  return (
    <div className={revealVariants({ className })} style={{ height }}>
      <div ref={content}>{children}</div>
    </div>
  );
};
